import { useLayouts } from "../LayoutsProvider";
import NoLayout from './NoLayout';
import HorizontalPreview from "./HorizontalPreview";
import { HorizontalSkeleton } from "./SkeletonsLayout";

const FooterLayout = () => {
  const { loading, layouts } = useLayouts();

  if ( loading ) return <HorizontalSkeleton />;
  
  let footerLayouts = [];

  if ( layouts.length > 0 ) {

    layouts.map((current, index) => {
      if (current.layout_value === 'footer') footerLayouts.push(current)
    })

    if ( layouts.length > 0 && footerLayouts.length > 0 ) {
      return <HorizontalPreview source="footer" layout={footerLayouts} />
    }
  }
  return <NoLayout source='footer' />
}

export default FooterLayout